import { createSelector } from 'reselect';
import ComparativeTrayUsageColumns
  from '../../containers/ComparativeTrayUsageColumns';
import ReportsDefinition from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.COMPARATIVE_TRAY_USAGE_941.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.COMPARATIVE_TRAY_USAGE_941.isLoading;

export const getData =
  ReportsDefinition.COMPARATIVE_TRAY_USAGE_941.getDataFunction();

export const getColumns =
  createSelector(getData, ComparativeTrayUsageColumns);
